import { Controller } from "@hotwired/stimulus";
import iconClose from "../../../../assets/images/global/preline/close.svg";

export default class extends Controller {
  static targets = ["articles", "selectedTags", "loadMore", "articleCard"];

  connect() {
    this.filteredArticlesArray = [...this.articleCardTargets];
    this.currentArticleIndex = this.getInitialArticleCount();

    this.addEventListeners();
    this.renderArticles();
  }

  addEventListeners() {
    document.addEventListener(
      "selectedOptionsChanged",
      ({ detail: { allSelectedOptions, currentOption } }) => {
        this._filterArticles(allSelectedOptions);
        if (currentOption.checked) {
          this._addSelectedTag(allSelectedOptions, currentOption.option);
        } else {
          this._removeSelectedTag(currentOption.option);
        }
      }
    );
  }

  renderArticles() {
    this.articleCardTargets.forEach((article) => {
      article.style.display = "none";
    });

    this.filteredArticlesArray.forEach((article, index) => {
      if (index < this.currentArticleIndex) {
        article.style.display = "flex";
      }
    });

    this.toggleLoadMoreButton();
  }

  loadMoreArticles() {
    this.currentArticleIndex += this._getColumns();
    this.renderArticles();
  }

  getInitialArticleCount() {
    return this._getColumns() * 2;
  }

  _getColumns() {
    this.articlesContainer = document.querySelector(".articles-body");
    const columnString = getComputedStyle(this.articlesContainer).gridTemplateColumns;
    return columnString.split(" ").length;
  }

  // Adds tags as labels to top of the page.
  _addSelectedTag(selectedTags, tag) {
    const tagElement = document.createElement("div");

    tagElement.classList.add("selected-tag", tag);
    tagElement.innerHTML = `<span class="flex bg-chalk-500 rounded-md px-2.5 py-1 gap-2">${tag.replace(
      /-/g,
      " "
    )}<img class="tag-remove-icon" src="${iconClose}"></img></span>`;

    this.selectedTagsTarget.appendChild(tagElement);
    this._getTagCloseEvent(selectedTags, tag, tagElement);
  }

  _removeSelectedTag(tag) {
    const tagElement = document.querySelector(`.${tag}`);

    this.selectedTagsTarget.removeChild(tagElement);
  }

  // Handles removing of tags through the labels.
  _getTagCloseEvent(selectedTags, tag, tagElement) {
    const tagRemoveIcon = tagElement.querySelector(".tag-remove-icon");

    tagRemoveIcon.addEventListener("click", () => {
      const index = selectedTags.indexOf(tag);

      selectedTags.splice(index, 1);
      this.selectedTagsTarget.removeChild(tagElement);

      // Dispatch event with removed tags that can be listened to by other controllers.
      const removedTagEvent = new CustomEvent("removeTagClicked", {
        detail: {
          tag: tag,
          selectedTags: selectedTags,
        },
      });
      document.dispatchEvent(removedTagEvent);

      this._filterArticles(selectedTags);
    });
  }

  _filterArticles(selectedTags) {
    if (!selectedTags.length) {
      this.filteredArticlesArray = [...this.articleCardTargets];
    } else {
      this.filteredArticlesArray = this.articleCardTargets.filter((article) =>
        selectedTags.includes(article.id)
      );
    }

    this.currentArticleIndex = this.getInitialArticleCount();

    this.renderArticles();

    if (selectedTags.length > 0) {
      this.selectedTagsTarget.classList.remove("hidden");
    } else {
      this.selectedTagsTarget.classList.add("hidden");
    }
  }

  toggleLoadMoreButton() {
    if (this.hasLoadMoreTarget) {
      if (this.currentArticleIndex >= this.filteredArticlesArray.length) {
        this.loadMoreTarget.classList.add("hidden");
      } else {
        this.loadMoreTarget.classList.remove("hidden");
      }
    }
  }
}
